import React, { Component } from "react";
import Breadcrumbs from 'core/components/SecondaryHeader'
import {Wrapper} from './components/Styled'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import LazyImage from 'core/components/LazyImage'
import Accordion from "../../../../core/components/Accordion";
import PuppySeekerNav from "../PuppySeekerNav";

class PuppyReady extends Component {

  constructor(props) {
    super(props)
  }

  static defaultProps = {
    title: '',
    cms: {},
  }

  static propTypes = {
    cms: PropTypes.object.isRequired,
  }
  
  getLeftItems () {
    return [
      {
        text: 'Home',
        isLink: true,
        isActive: true,
        props: {
          href: '/'
        }
      },
      {
        text: 'Ready for a Puppy',
        isLink: false,
        isActive: false,
        props: {
          href: '/'
        }
      }
    ]
  }

  removeHTMLtags( string ) {
    let regex = /(<([^>]+)>)/ig
    return (string) ? string.replace(regex, "") : ''
  } 

  render() {

    return (
      <div>
      <div className='marketplace__top-image'>

        <Breadcrumbs items={this.getLeftItems()} />

      </div>

      <Wrapper className={`static-page`}>
        <div className='static-page__section'>
          <div className='header' >
              <h1> { this.removeHTMLtags( this.props.cms['things-to-consider-heading'] ) }</h1>
          </div>
          <PuppySeekerNav />
          <div className='section-1' >
              <div className='img-wrap' >
                  <LazyImage src={ this.removeHTMLtags( this.props.cms['things-to-consider-section-1-image'] ) }  className='section-1-img' />
              </div>
              <div className='text-wrap' >
                  <h2> { this.removeHTMLtags( this.props.cms['things-to-consider-section-1-heading'] ) } </h2>
                  <p dangerouslySetInnerHTML={{ __html:  this.props.cms['things-to-consider-section-1-text']  }} /> 
              </div>
          </div>
          <div>

          <div className='section-2' >
            <h2> { this.removeHTMLtags( this.props.cms['things-to-consider-section-2-heading'] ) }</h2>

            <div className="accordion-wrap" >
              <Accordion content={ this.props.cms['things-to-consider-accordion-1-content'] } title={ this.removeHTMLtags( this.props.cms['things-to-consider-accordion-1-title'] )}  />
              <Accordion content={ this.props.cms['things-to-consider-accordion-2-content'] } title={ this.removeHTMLtags( this.props.cms['things-to-consider-accordion-2-title'] )}/>
              <Accordion content={ this.props.cms['things-to-consider-accordion-3-content'] } title={ this.removeHTMLtags( this.props.cms['things-to-consider-accordion-3-title'] )} />
              <Accordion content={ this.props.cms['things-to-consider-accordion-4-content'] } title={ this.removeHTMLtags( this.props.cms['things-to-consider-accordion-4-title'] )}/>
            </div>
          </div>

            <div className='section-3' >
                <div className='text-wrap' >
                  <h2> { this.removeHTMLtags( this.props.cms['things-to-consider-section-3-text-1'] ) } </h2>
                  <div className="button-wrap" >
                    <button className="button" onClick={() => this.props.history.push('/choosing-a-breed')} > { this.removeHTMLtags( this.props.cms['things-to-consider-section-3-button-1-text'] ) } </button>
                  </div>
                  <h2> { this.removeHTMLtags( this.props.cms['things-to-consider-section-3-text-2'] ) } </h2>
                  <div className="button-wrap" >
                    <a className="button" href={ this.removeHTMLtags( this.props.cms['things-to-consider-section-3-button-2-link'] ) } target="_blank"> { this.props.cms['things-to-consider-section-3-button-2-text'] } </a>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </Wrapper>
    </div>
    )
  }

  }

  const mapStateToProps = state => ({
    cms: state.app.cms,
  })

  export default connect(
    mapStateToProps,
    null
  )(PuppyReady)
  